/**
 * SixtySix - "Get Started" Interactive Customer Onboarding Guide
 * Stepped Editorial View Controller & Vanilla JS Component
 */

(function () {
  function initGetStartedGuide() {
    const guideRoot = document.querySelector('.gs-guide');
    if (!guideRoot) return;

    const navItems = guideRoot.querySelectorAll('.gs-nav-item');
    const stepViews = guideRoot.querySelectorAll('.gs-step-view');
    const prevBtns = guideRoot.querySelectorAll('.js-step-prev');
    const nextBtns = guideRoot.querySelectorAll('.js-step-next');

    // ------------------------------------------------------------------------
    // Step View Switcher Function
    // ------------------------------------------------------------------------
    function setActiveStep(targetId, shouldScroll = false) {
      const cleanId = targetId.replace('#', '');
      const targetView = guideRoot.querySelector(`#${cleanId}`);
      if (!targetView) return;

      const scroller = guideRoot.querySelector('.gs-nav-scroller');

      // Update Nav Pills
      navItems.forEach((nav) => {
        const href = nav.getAttribute('href') || '';
        if (href.replace('#', '') === cleanId) {
          nav.classList.add('is-active');
          // Only scroll horizontal nav container if it actually overflows on small screens
          if (scroller && scroller.scrollWidth > scroller.clientWidth + 5) {
            const scrollerRect = scroller.getBoundingClientRect();
            const navRect = nav.getBoundingClientRect();
            const offset = (navRect.left - scrollerRect.left) - (scroller.clientWidth / 2) + (navRect.width / 2);
            scroller.scrollBy({ left: offset, behavior: 'smooth' });
          }
        } else {
          nav.classList.remove('is-active');
        }
      });

      // Switch Step Views with smooth animation
      stepViews.forEach((view) => {
        if (view.id === cleanId) {
          view.classList.add('is-active');
        } else {
          view.classList.remove('is-active');
        }
      });

      // Update URL hash without jumping
      if (history.replaceState) {
        history.replaceState(null, null, `#${cleanId}`);
      }

      if (shouldScroll) {
        const navWrapper = guideRoot.querySelector('.gs-nav-wrapper');
        if (navWrapper) {
          const headerEl = document.querySelector('.header-sticky, .header');
          const headerHeight = headerEl ? headerEl.offsetHeight : 70;
          const elementPosition = navWrapper.getBoundingClientRect().top;
          
          // Only scroll the window if the navigation is currently scrolled out of view
          if (elementPosition < 0 || elementPosition > window.innerHeight * 0.7) {
            const offsetPosition = elementPosition + window.pageYOffset - headerHeight - 16;
            window.scrollTo({
              top: Math.max(0, offsetPosition),
              behavior: 'smooth'
            });
          }
        }
      }
    }

    // Nav Item Click Listeners - smooth switch without jumping
    navItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = item.getAttribute('href');
        if (targetId) {
          setActiveStep(targetId, false);
        }
      });
    });

    // Prev / Next Button Listeners
    prevBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.targetStep;
        if (targetId) {
          setActiveStep(targetId, true);
        }
      });
    });

    nextBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.targetStep;
        if (targetId) {
          setActiveStep(targetId, true);
        }
      });
    });

    // Check Initial URL Hash
    if (window.location.hash) {
      const initialStep = guideRoot.querySelector(window.location.hash);
      if (initialStep && initialStep.classList.contains('gs-step-view')) {
        setActiveStep(window.location.hash, false);
      }
    }

    // ------------------------------------------------------------------------
    // 1. Interactive Unboxing Checklist
    // ------------------------------------------------------------------------
    const checklistItems = guideRoot.querySelectorAll('.gs-unboxing-item');
    checklistItems.forEach((item, index) => {
      const storageKey = `sixtysix_unboxing_item_${index}`;
      if (sessionStorage.getItem(storageKey) === 'true') {
        item.classList.add('is-checked');
      }

      item.addEventListener('click', () => {
        const isChecked = item.classList.toggle('is-checked');
        sessionStorage.setItem(storageKey, isChecked ? 'true' : 'false');
      });
    });

    // ------------------------------------------------------------------------
    // 2. Interactive Fit Studio Symptom Switcher
    // ------------------------------------------------------------------------
    const fitTabBtns = guideRoot.querySelectorAll('.gs-fit-tab-btn');
    const fitPanels = guideRoot.querySelectorAll('.gs-fit-content-panel');

    fitTabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.fitTarget;

        fitTabBtns.forEach((b) => b.classList.remove('is-active'));
        fitPanels.forEach((p) => p.classList.remove('is-active'));

        btn.classList.add('is-active');
        const targetPanel = guideRoot.querySelector(`#${targetId}`);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });

    // ------------------------------------------------------------------------
    // 3. Care Masterclass Category Filter
    // ------------------------------------------------------------------------
    const careCatBtns = guideRoot.querySelectorAll('.gs-care-cat-btn');
    const carePanels = guideRoot.querySelectorAll('.gs-care-panel');

    careCatBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetCat = btn.dataset.careCat;

        careCatBtns.forEach((b) => b.classList.remove('is-active'));
        carePanels.forEach((p) => p.classList.remove('is-active'));

        btn.classList.add('is-active');
        const targetPanel = guideRoot.querySelector(`#care-panel-${targetCat}`);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });

    // ------------------------------------------------------------------------
    // 4. In-Page Yotpo Review Modal Controller
    // ------------------------------------------------------------------------
    const yotpoModal = guideRoot.querySelector('#gs-yotpo-modal');
    const openModalBtns = guideRoot.querySelectorAll('.js-open-yotpo-review-modal');
    const closeModalBtns = guideRoot.querySelectorAll('.js-close-yotpo-modal');

    function openYotpoModal() {
      if (!yotpoModal) return;
      yotpoModal.classList.add('is-open');
      yotpoModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Refresh Yotpo widget if available
      if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
        window.yotpo.refreshWidgets();
      } else if (window.Yotpo && typeof window.Yotpo.refreshWidgets === 'function') {
        window.Yotpo.refreshWidgets();
      }

      // Auto-trigger write review button inside Yotpo if present
      setTimeout(() => {
        const writeBtn = yotpoModal.querySelector('.write-review-button, .yotpo-new-review-btn, .write-a-review-button, button[data-yotpo-element-id="write-review-button"]');
        if (writeBtn) {
          writeBtn.click();
        }
      }, 400);
    }

    function closeYotpoModal() {
      if (!yotpoModal) return;
      yotpoModal.classList.remove('is-open');
      yotpoModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openModalBtns.forEach((btn) => btn.addEventListener('click', openYotpoModal));
    closeModalBtns.forEach((btn) => btn.addEventListener('click', closeYotpoModal));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && yotpoModal && yotpoModal.classList.contains('is-open')) {
        closeYotpoModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGetStartedGuide);
  } else {
    initGetStartedGuide();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.gs-guide') || e.target.classList.contains('gs-guide')) {
      initGetStartedGuide();
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    const blockEl = e.target;
    if (blockEl && blockEl.classList.contains('gs-step-view')) {
      const targetId = blockEl.id;
      const navItem = document.querySelector(`.gs-nav-item[href="#${targetId}"]`);
      if (navItem) {
        navItem.click();
      }
    }
  });
})();
